module.exports = __webpack_public_path__ + "img/img-zf-06.png";